<template>
  <div class="home">
   
  <v-row>
                <v-col md='4' cols="12">
                    <v-card @click='goTo("refurbishers")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Total Refurbishers</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{dashboardValue.totalRefurbisher}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                <v-col  md='4'  cols="12">
                    <v-card @click='goTo("npos")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Total Npos</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{dashboardValue.totalNpo}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                    <v-col  md='4'  cols="12">
                    <v-card @click='goTo("donors")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Total Donors</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{dashboardValue.totalDonor}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                
                     
            </v-row>
    
  </div>
</template>

<script>
const fb = require("../../firebaseconfig");
import { mapFields } from "vuex-map-fields";
export default {
  name: 'Home',
    mounted() {
              fb.auth.currentUser.getIdTokenResult(true).then((idTokenResult) => {
            this.npoId = idTokenResult.claims.role;
            if (idTokenResult.claims.role !== "admin") {
                alert("Unauthorize access");
                fb.auth.signOut();
            }
            this.updateDashboard();
        })
  },
  methods : {
     goTo(route){
            this.$router.push(route)
        },
            updateDashboard() {

                fb.db.collection("admin").doc("counter").onSnapshot((data) => {
                    this.dashboardValue = data.data();
                })
        }
  },
  data() {
    return{
      npoId : null,
      dashboardValue : {
          totalRefurbisher : 0,
          totalNpo : 0,
          totalDonor : 0,
      },
      ngo : []
    }
  },
  components: {
    
  },
    computed: {
    ...mapFields(["globalRefurbisher"]
    )
  }
}
</script>
